// eslint-disable-next-line import/no-unresolved
import generateBarcode from 'pdf417';

// eslint-disable-next-line import/prefer-default-export
export const mix2DBarcode = ({ shipmentId = '', items = [] }) => {
  // Amazon box-content 2D barcode must contain ONLY these fields, in this order.
  // Encoding arbitrary keys (e.g. msku, name, sku_id) corrupts the scanned content,
  // and omitting `exp` drops the expiry. Whitelist keeps it correct regardless of
  // what extra fields the caller passes in each item.
  const ALLOWED_KEYS = ['fnsku', 'qty', 'exp'];
  let stringToEncode = `AMZN,PO:${shipmentId}`;
  items.forEach((item) => {
    ALLOWED_KEYS.forEach((key) => {
      const value = item?.[key];
      if (value) {
        stringToEncode += `,${key.toUpperCase()}:${value.toString().toUpperCase()}`;
      }
    });
  });

  return generateBarcode(stringToEncode, 15, 15);
};
